export const getLabelByField = field => (
	programFields.find(f => f.field === field) ? programFields.find(f => f.field === field).label : field
);

export const programFields = [
	{ label: "Id" ,field: "Id" },
	{ label: "Owner" ,field: "OwnerId" },
	{ label: "Program Name" ,field: "Name", isVisible: true, isDefault:true }, // added for clarity
	{ label: "Owner Name" ,field: "Owner.Name" },
	{ label: "Program" ,field: "Name" },

	{ label: "Account Name" ,field: "Account_Name__r.Name" },
	{ label: "Cloud Provider" ,field: "Cloud_Provider__c" },

	{ label: "Program Type" ,field: "Program__c" },
	{ label: "Priority" ,field: "Priority__c" ,isVisible: true, isDefault: true },

	{ label: "Integrated Service" ,field: "Integrated_Service__c" },
	{ label: "Competency" ,field: "Competency__c" },

	{ label: "Status" ,field: "Status__c" ,isVisible: true, isDefault: true },
	{ label: "Progress" ,field: "Progress__c" },

	{ label: "Due Date" ,field: "Due_Date__c" },
	{ label: "Expiration Date" ,field: "Expiration_Date__c", isVisible: true, isDefault: true },

	{ label: "Description" ,field: "Description__c" },
	{ label: "Last Status Update Date" ,field: "Last_Status_Update_Date__c" },

	{ label: "Actual Date" ,field: "Actual_Date__c" },

	{ label: "Next Step" ,field: "Next_Step__c", isVisible: true, isDefault: true },
	{ label: "Next Step Date" ,field: "Next_Step_Date__c", isVisible: true, isDefault: true },
	{ label: "Next Step POC" ,field: "Next_Step_POC__r.Name" , isVisible: true },
	{ label: "Next Step POC" ,field: "Next_Step_POC__c" },
	{ label: "Next Step Owner" ,field: "Next_Step_Owner__c" ,},
	{ label: "Next Step Owner" ,field: "Next_Step_Owner__r.Name", isVisible: true },

	{ label: "Created By" ,field: "CreatedBy.Name", isVisible: true },
	{ label: "Last Modified By" ,field: "LastModifiedBy.Name", isVisible: true },
];
export const getDefaultFields = () => programFields.filter(f => f.isDefault);
export const getDisplayFields = (isDefault=false,keys = null) => {
  const visibleFields = programFields
  .filter(f => f.isVisible)
  .filter(f => isDefault ? f.isDefault : true);

  if (!keys||keys.length==0) return visibleFields;

  return keys
    .map(key => visibleFields.find(f => f.field === key))
    .filter(Boolean);
};
